export const util = {
  isTel (str) {
    var reg = /^[1][3,4,5,7,8][0-9]{9}$/
    return reg.test(str)
  },
  isEmail (str) {
    var reg = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/
    return reg.test(str)
  },
  isCardNo (str) {
    var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
    return reg.test(str)
  },
  dayDiff (startDate, endDate) {
    let s1 = new Date(startDate.replace(/-/g, '/'))
    let s2 = endDate ? new Date(endDate.replace(/-/g, '/')) : new Date()// 当前日期：2017-04-24
    let days = s2.getTime() - s1.getTime()
    return Math.abs(parseInt(days / (1000 * 60 * 60 * 24)))
  },
  addDay (startDate, day) {
    startDate = new Date(startDate)
    startDate = +startDate + 1000 * 60 * 60 * 24 * day
    startDate = new Date(startDate)
    let month = startDate.getMonth() + 1
    let days = startDate.getDate()
    month = month < 10 ? ('0' + month) : month
    day = day < 10 ? ('0' + day) : day
    var nextStartDate = startDate.getFullYear() + '-' + month + '-' + days
    return nextStartDate
  },
  formatDate (dateStr) {
    let date = new Date(dateStr)
    let year = date.getFullYear()
    let month = date.getMonth() + 1
    let day = date.getDate()
    month = month < 10 ? ('0' + month) : month
    day = day < 10 ? ('0' + day) : day
    return `${year}-${month}-${day}`
  }
}

const Util = {}
Util.install = function (Vue) {
  // Vue.prototype.$http = http
  Vue.mixin({
    beforeCreate () {
      if (!Vue.prototype.$util) {
        Vue.prototype.$util = util
      }
    }
  })
}

export default Util
